import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./styles.module.scss";
import ellowLogo from "../../../assets/images/ellow-logo.svg";
import CompanyDetails from "./companyDetails";
import JobDetails from "./jobDetails";
import { Headline4} from "ellow-web-ui-components-library";
import StepperDefault from '../../../compopnents/stepper';
import NotificationAlert from '../../../compopnents/notification';
import { addCustomerDetails, updateCustomerDetails, getUserDetails} from './services'
import mixpanelData, { viewedpageMixpanel } from "../../../utils/mixpanel";
import { checkSize } from "../../../utils/ellowutils";


function CustomerSignup() {

  let navigate = useNavigate()

  const [active_status , setActive_status] = useState<any>()
  const [apiStatus, setApiStatus] = useState<any>()
  const [step, setStep] = useState<number>(0)
  const [disableBtn, setDisableBtn] = useState<boolean>(false)
  const [customerId, setCustomerId] = useState<string>()
  const [flag, setFlag] = useState<boolean>(false)
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [isExistingCustomer, setIsExistingCustomer] = useState<boolean>(false)
  const [defaultCompanyValues, setDefaultCompanyValues] = useState<{skills: {id: number , name: string}[], workEmail: '', phoneNumber: '',companyName: '',designation: ''}>({ workEmail: '', phoneNumber: '', companyName:'',designation:'', skills: [{id: 0 , name: ''}]})
  const [defaultJobdetailValues, setDefaultJobdetailValues] = useState<{
    website: string,
    workWithRemote: number,
    firstName: string,
    size: number,
    googleLocations: any
    // skills: {id: number , name: string}[],
  }>({   website: '', workWithRemote: 5, firstName: '', size: 5, googleLocations: ''}) 
 const [userId, setUserId] = useState<string>('')
  const items = [
    {
      label: "Job Details",
      icon: "one",
    },
    {
      label: "Company Details",
      icon: "two",
    },
    // {
    //   label: "Schedule a call",
    //   icon: "three",
    // }
  ];

     // << url params are passed for verification purpose >>
     let query: any = window.location.href;
     let urlParams: any = new URL(query);
     let passedEmail: any = urlParams.search.slice(7)
     let email1: any = passedEmail.replace('%40', '@')
 
  useEffect(() => {

    if(email1)
    {
      getCustomerDetails(email1)
    }
    
      viewedpageMixpanel();
     
    // if (step===0 && !flag){
    //   setMessage('Please tell us more about you')
    //   setNotification(true);
    //   setTimeout(() => {
    //    setNotification(false)
    //  }, 5000);
    // }
  },[email1]);
  
   
 const getCustomerDetails = (email: string) => {
   
  getUserDetails(email).then((response) => {  
    
    //<<MATCHING EMAIL>>// 
    if ( response && response.status === '2') {
      setFlag(true)
      setCustomerId(response.data[0] && response.data[0].customer_id)
      setApiStatus(response.status)
      if(response.data[0].userData){
        setActive_status(response.data[0].userData[0].active_status)
        setUserId(response.data[0].userData[0].user_id)
        setDefaultCompanyValues(response.data[0] && response.data[0] && response.data[0].customer_metadata)
        setDefaultJobdetailValues(response.data[0] && response.data[0] && response.data[0].customer_metadata)
      }
      if(response.data[0].customer_status && response.data[0].customer_status === 2){
        setIsExistingCustomer(true)
      }
      setMessage("Customer with same email id already exists")
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 5000);
    }
   
    //<<NEW USER>>//
    if( response && response.status === '1') {
      setFlag(false)
      setApiStatus(response.status)
      setDefaultCompanyValues(response.data)
      setDefaultJobdetailValues({website: '', workWithRemote: 5, firstName: '', size: 5, googleLocations: ''})
      setActive_status(1)
    }
    
    //<<MATCHING DOMAIN>>//
    if ( response && response.status === '3') {
      setFlag(false)
      setApiStatus(response.status)
      setIsExistingCustomer(true)
      if(response.data[0].userData){
        setActive_status(response.data[0].userData[0].active_status)
        setUserId(response.data[0].userData[0].user_id)
        setDefaultCompanyValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
        setDefaultJobdetailValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
      }
      if(!response.data[0].userData){
        setActive_status(1)
        setDefaultCompanyValues(response.data[0] && response.data[0].customer_metadata)
        setDefaultJobdetailValues(response.data[0] && response.data[0].customer_metadata)
      }
      setMessage('Your company already exists on Ellow platform,Company details will be prefilled and you would be added as an additional user post completing the registration process')
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 5000);
    }
    
    //<<BACKEND ERROR>>//
    if ( response && response.status === '2') {
      // setMessage('Failed, please try again later!')
      // setNotification(true)
      // setTimeout(() => {
      //   setNotification(false)
      // }, 5000);
    }

    //Gmail Domain
    if(response && response.status === '4'){
      setFlag(true)
      setApiStatus(response.status)
      setMessage('gmail.com - This domain is not acceptable')
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 5000);
    }

  })
  .catch((err: any) => {

  })

  }

 const handleSubmit = (data: any) => {

  setDisableBtn(true)
  //<<Existing user OR new user>>//
  if ( flag === true && active_status!== 2 && active_status!== 4 && active_status!== 5 && active_status!== 6 && active_status!== 7 && active_status!== 8 && apiStatus !== 4) {
    
    updateCustomerDetails(data).then(response => {      
      if (response && response.status === 1 && response.data.activeStatus === 2) {
        navigate(`/verification`, {
          state: 1
        });
        mixpanelData('MT - Customer updates registration', {
          'source': 'Excisting customer updates registration details',
          'Company name': response && response.data && response.data.customer_metadata && response.data.customer_metadata.companyName,
          'work email': response && response.data && response.data.customer_metadata && response.data.customer_metadata.workEmail,
          'Phone number': response && response.data && response.data.customer_metadata && response.data.customer_metadata.phoneNumber,
          'Skills': response && response.data && response.data.customer_metadata && response.data.customer_metadata.skills && response.data.customer_metadata.skills.toString(),
          'First Name': response && response.data && response.data.customer_metadata && response.data.customer_metadata.firstName,
          'Company Size': response && response.data && response.data.customer_metadata && response.data.customer_metadata.size && checkSize(response.data.customer_metadata.size)?.name,
          'company Website': response && response.data && response.data.customer_metadata && response.data.customer_metadata.website,
          'Work with remote' : response && response.data && response.data.customer_metadata && response.data.customer_metadata.workWithRemote === 0 ? 'Yes' : 'No',
        })
        mixpanelData('New MT - Company registered', {
          'distinct_id': response && response.data && response.data.customer_metadata && response.data.customer_metadata.workEmail,
          'User email': response && response.data && response.data.customer_metadata && response.data.customer_metadata.workEmail,
          'Phone number' : response && response.data && response.data.customer_metadata && response.data.customer_metadata.phoneNumber,
          'Company name': response && response.data && response.data.customer_metadata && response.data.customer_metadata.companyName,
          'Designation': response && response.data && response.data.customer_metadata && response.data.customer_metadata.designaion,
          'Skills': response && response.data && response.data.customer_metadata && response.data.customer_metadata.skills && response.data.customer_metadata.skills.map((item: any) => {return (item.name)}),
          'Remote work': response && response.data && response.data.customer_metadata && response.data.customer_metadata.workWithRemote === 0 ? 'Yes' : 'No',
          'Company size': response && response.data && response.data.customer_metadata && response.data.customer_metadata.size && checkSize(response.data.customer_metadata.size)?.name,
          'Company website': response && response.data && response.data.customer_metadata && response.data.customer_metadata.website,
          'User designation': response && response.data && response.data.customer_metadata && response.data.customer_metadata.designation,
          'User name': response && response.data && response.data.customer_metadata.firstName,
          // 'Company id': customerId
        })
      }
      if (response && response.status === 1) {
        setStep(step + 1)
        setDisableBtn(false)
        if ( response.data.customer_status === 1 || response.data.activeStatus  === 2) {
          switch (step){
            case 0:
              // setMessage('Company details are saved successfully')
              break
            case 1:
              // setMessage('Job Details are saved successfully')
              navigate(`/verification`, {
                state: 1
              });
              break
          }
          // setNotification(true)
          // setTimeout(() => {
          //   setNotification(false)
          //   setStep(step + 1)
          // }, 5000);
        }
        
      }
    })
    .catch((err: any) => {
     console.log('err =>', err);
   })
  }
  
  //<<Completed user but not verified>>//
  //  if (active_status === 2) {
  //   navigate(`/verification`, {
  //     state: 1
  //   });
  // }
  
  //<<Excisting verified user>>//
  if(active_status === 4){
    // setMessage('A user from your organization already exits')
    // setNotification(true)
    // setTimeout(() => {
    //   setNotification(false)
    // }, 5000);
    navigate(`/customerlogin`, {
      state: 1
    });

   }
   
   //<<Rejected company>>//
   if (flag && (active_status === 5 || active_status === 6 || active_status === 7 || active_status === 8)) {
    setMessage('We are unable to process this request,  Please reach out to team@ellow.io')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      setDisableBtn(false)
    }, 5000);
    setDisableBtn(false)
   }
  
   //<<NEW USER>>//
  if(!flag) {
    addCustomerDetails(data).then(response => {
      if (response && response.status === 1) {
        mixpanelData('MT - Registration', {
          'source': 'New Customer registered',
          'workmail': data && data.customerMetadata && data.customerMetadata.workEmail,
          'Company Name': data && data.customerMetadata && data.customerMetadata.companyName,
          'Phone Number': data && data.customerMetadata && data.customerMetadata.phoneNumber,
          'Skills': data && data.customerMetadata && data.customerMetadata.skills,
          'Company Type': 'Hirer'
        })     
        mixpanelData('New MT - Company drafted', {
          'distinct_id': data && data.customerMetadata && data.customerMetadata.workEmail,
          'User email': data && data.customerMetadata && data.customerMetadata.workEmail,
          'Company name': data && data.customerMetadata && data.customerMetadata.companyName,
          'Phone number': data && data.customerMetadata && data.customerMetadata.phoneNumber,
          'Skills': data && data.customerMetadata && data.customerMetadata.skills && data.customerMetadata.skills.map((item : any) => {return(item.name)}) ,
          'Company type': 'Hirer',
          'designation' : data && data.customerMetadata && data.customerMetadata.designation,
          'Company id': response && response.data && response.data.customer_id,
          'User name': response && response.data && response.data.customer_metadata.firstName
        })

        setEmail(data.emailId)    
        setCustomerId(response.data.customer_id)
        setDisableBtn(false)
        setStep(step + 1)
        setUserId(response.data.userId)
        setMessage('Company details are saved successfully')
        setNotification(true)
        setFlag(true)
        setTimeout(() => {
          setNotification(false)
          setStep(step + 1)
        }, 5000);
      }
    })
    .catch((err: any) => {
     console.log('err =>', err);
   })
  }
  
  if(apiStatus === 4){
    setDisableBtn(false)
    setMessage('gmail.com - This domain is not acceptable , Please try a different domain')
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 5000);
  }
 }

 const Back = () => {
  setStep(step - 1)
  const mail = localStorage.getItem('email') || email
  setFlag(true)
  getCustomerDetails(mail)
 }
 
 const onClose = () => {
   setNotification(false)
 }
  
  return (
    <section className={Styles.profileWrapper}>
    <div className={Styles.header}>
      <img src={ellowLogo} alt="ellow.io" />
    </div>
    <div className={Styles.headline4}>
        <Headline4>Please help us understand your requirements</Headline4>
      </div>
      <p className={Styles.subtitle}>We at ellow.io practice high security standards to keep the data you enter safe and secured</p>

    <div className="container">
      <div className={Styles.profileStepper}>
      <StepperDefault items={items} value={step} />
      </div>
        {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
        </NotificationAlert> }
      <div className={Styles.profileSteps}>
        <div className={Styles.profileStepForm}>
            {step === 0 && <CompanyDetails ClickHandler={handleSubmit} Back={Back} defaultValues={defaultCompanyValues} newBlur={getCustomerDetails} customerId={customerId} status={apiStatus} disable={disableBtn} userId={userId} />}
            {step === 1 && <JobDetails defaultValues={defaultJobdetailValues} emailId={email} ClickHandler={handleSubmit} Back={Back} customerId={customerId} disable={disableBtn} userId={userId} status={apiStatus} isExistingCustomer={isExistingCustomer}/>}
        </div>
      </div>
    </div>
  </section>
  );
}

export default CustomerSignup